module.exports = __webpack_public_path__ + "img/line_poster.3a22ad5b.png";